module.exports = __webpack_public_path__ + "static/img/apple-touch-icon-120x120.8df8296.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/apple-touch-icon-120x120.png
// module id = 412
// module chunks = 1